import React from "react";
import { useTranslation } from "react-i18next";
import Highcharts from "highcharts";
import html2canvas from "html2canvas";
import HighchartsReact from "highcharts-react-official";

const InteractionVideoMoyenne = (props) => {
    
    const { t } = useTranslation();

    const printChart = (event) => {
        event.preventDefault();

        let target = event.target;
        let parent = target.parentElement.parentElement;
        let name = parent.getAttribute("data-value");
        parent.classList.add("capture_style");

        html2canvas(parent, {
        onclone: (document) => {},
        }).then((canvas) => {
        const data = canvas.toDataURL("image/jpg");
        const link = document.createElement("a");

        if (typeof link.download === "string") {
            link.href = data;
            link.download = name + ".jpg";

            parent.classList.remove("capture_style");

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(data);
        }
        });
    };

    const benchmark_video = props?.state?.reportingData?.ytb?.benchmark?.bench_video_ytb;   

    let options = {
        chart: {
          type: "column",
        },
        title: {
          text: t("Benchmark.moyenne_interactions_video"),
          align: "left",
          margin: 50,
        },
        subtitle: {
          text: t("Benchmark.moyenne_interactions_video_txt"),
          align: "left",
          margin: 10,
        },
        tooltip: {
          enabled: false,
        },
        xAxis: {
          labels: {
            enabled: false,
          },
          categories: [],
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        legend: {
          enabled: true,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
                enabled: true,
                format: '{point.y:.2f}%'
            },
          },
        },
        series: [{}]
    };

    const arr_data_option = [];
    for (const bench_mark in benchmark_video) {
        // Vérifier la valeur de tt.page_id et définir la couleur en conséquence
        let color;
        if (benchmark_video[bench_mark].page_id === 426629) {
          //-- Orange
          color = "#f16e00";
        } else if (benchmark_video[bench_mark].page_id === 426631) {
          //-- Ooredoo
          color = "#ed1c24";
        } else if (benchmark_video[bench_mark].page_id === 426630) {
          //-- Tunisie
          color = "#001e8c";
        }

        const total_video = Number(benchmark_video[bench_mark]?.video || 0) + Number(benchmark_video[bench_mark]?.shorts || 0);
        const interactions_total = 
            Number(benchmark_video[bench_mark]?.views_video || 0) + 
            Number(benchmark_video[bench_mark]?.comments_video || 0) + 
            Number(benchmark_video[bench_mark]?.likes_video || 0) + 
            Number(benchmark_video[bench_mark]?.views_shorts || 0) + 
            Number(benchmark_video[bench_mark]?.comments_shorts || 0) + 
            Number(benchmark_video[bench_mark]?.likes_shorts || 0);

        const interactions = total_video > 0 ? interactions_total / total_video: 0;
        
        const arr = {
          name: benchmark_video[bench_mark].name_page,
          data: [interactions],
          color: color,
        };
        arr_data_option.push(arr);
        
    }
    arr_data_option.map((entry, index) => {
      options.series.push(entry);
    });

    function remove_empty_value(arr) {
        var index;
        arr.some(function (obj, i) {
        return Object.keys(obj).length === 0 && obj.constructor === Object
            ? ((index = i), true)
            : false;
        });
        arr.shift(index);
        return index;
    }
    remove_empty_value(options.series);

    return (
      <div>
        <div className="highchart_block mt-8">
          <div data-value={t("Benchmark.moyenne_interactions_video")} className="highchart_block1">
            <div data-html2canvas-ignore className="flex items-center justify-end">
              <button
                onClick={printChart}
                className="mx-5 w-5 h-5 print_capture"
              ></button>
            </div>

            <HighchartsReact highcharts={Highcharts} options={options} />

            <div className="capture_style"></div>
          </div>
        </div>
      </div>
    );
};

export default InteractionVideoMoyenne;
